module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "default-active": _vm.activeIndex,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/home/pharmacy/nowStock"
    }
  }, [_vm._v("当前库存")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/pharmacy/outSummary"
    }
  }, [_vm._v("出库汇总")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/pharmacy/outHouse"
    }
  }, [_vm._v("出库管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/pharmacy/intoHouse"
    }
  }, [_vm._v("入库管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/pharmacy/checkStock"
    }
  }, [_vm._v("库存盘点")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ece5943e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/menu.vue
// module id = 1050
// module chunks = 2